import DBOperationsComb from "src/utils/dbOperationsComb";

async function sendEmail(dataObj) {
  // console.log("dataObj :", dataObj);
  // return

  return await DBOperationsComb.invokeEdgeFunction("send-email", {
    body: {
      from: dataObj.from,
      to: dataObj.to,
      subject: dataObj.subject,
      body: dataObj.body,
      attachments: dataObj.attachments,
      cc: dataObj.cc
    }
  });
}

async function sendEmailV2(dataObj) {
  return await DBOperationsComb.invokeEdgeFunction("send-email-v2", {
    body: {
      email_template_id: dataObj.emailTemplateId,
      data: dataObj.data,
      role_recipients: dataObj.roleRecipients,
      subject: dataObj.subject,
      body: dataObj.body,
      attachments: dataObj.attachments
    }
  });
}

async function getManagerInfo(userId) {
  return await DBOperationsComb.invokeEdgeFunction("get-manager-info", {
    body: {
      userId
    }
  });
}

export default {
  sendEmail,
  sendEmailV2,
  getManagerInfo
};
